@if (finishedSpinnerCheck()) {
<div
  class="fixed top-0 left-0 w-full h-full overlay flex justify-content-center align-items-center">
  <mat-card
    class="p-4 flex flex-column justify-content-center align-items-center text-center">
    <mat-spinner diameter="50" />
  </mat-card>
</div>
}
